import React, { Component } from 'react';

import ValidationError from '~/components/shared/validation_error';
import HttpRequestor from '~/components/utils/http_requestor';
import I18n from '~/utils/translations';
import { joinClasses } from '~/components/utils/react_helper';

import Cross from '~/images/close-icon-blue.svg';

export default class PropertiesDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: '',
      searchResults: [],
    };
  }

  render() {
    return (
      <div className="properties-dropdown">
        {!this.props.selectedProperty && (
          <input
            className="properties-dropdown__input"
            value={this.state.inputValue}
            onChange={this.onInputChange}
            placeholder={I18n.t('pages.agents_form.step_1.input_placeholders.address')}
          />
        )}

        {this.props.selectedProperty && this.renderSearchResult(this.props.selectedProperty)}

        {!this.props.selectedProperty && this.hasFilteredProperties && (
          <div className="properties-dropdown__properties">
            <span className="properties-dropdown__matches">{I18n.t('pages.agents_form.step_1.matches')}</span>
            <div className="properties-dropdown__results-scroll">
              {this.state.searchResults.map(this.renderSearchResult)}
            </div>
          </div>
        )}

        <ValidationError version="2" errors={this.props.errors} />
      </div>
    );
  }

  renderSearchResult = (result) => {
    return (
      <div key={result.id} className="properties-dropdown__property">
        <div
          data-property-id={result.id}
          className={this.propertyItemClasses}
          onClick={() => this.props.onPropertySelect(result)}
        >
          <div className="properties-dropdown__property-details">{result.attributes.full_address}</div>

          {this.props.selectedProperty && (
            <img className="properties-dropdown__clear" src={Cross} onClick={this.onClearClick} />
          )}
        </div>
      </div>
    );
  };

  onInputChange = (e) => {
    this.setState({
      inputValue: e.target.value,
      searchResults: this.searchProperties(e.target.value),
    });
  };

  onClearClick = () => {
    this.setState({ inputValue: '', searchResults: [] }, () => {
      this.props.clearSelection();
    });
  };

  searchProperties = (filterTerm) => {
    if (filterTerm.length === 0) {
      return [];
    }

    const portfolioIds = this.props.portfolios;

    const url = new URL('/search', window.location.origin);
    url.searchParams.append('term', filterTerm);

    // Append each portfolio ID as a separate parameter in the URL
    portfolioIds.forEach((portfolioId) => {
      url.searchParams.append('portfolio_ids[]', portfolioId);
    });

    const requestor = new HttpRequestor();
    requestor.call(url, 'GET').then(this._lookupSuccess).catch(this._lookupError);
  };

  _lookupSuccess = (response) => {
    this.setState({ searchResults: response.items });
  };

  _lookupError = (response) => {
    this.setState({ searchResults: [], searchError: 'Something went wrong, please try again' });
  };

  get propertyItemClasses() {
    return joinClasses([
      'properties-dropdown__property-container',
      this.props.selectedProperty && 'properties-dropdown__property-container--selected',
    ]);
  }

  get hasFilteredProperties() {
    return this.state.searchResults && this.state.searchResults.length > 0;
  }

  get anyErrors() {
    return this.props.errors && this.props.errors.length > 0;
  }
}
